// URL configuration
const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:8000/api'

// Support multiple base URLs - use current domain or fallback to first configured domain
const getBaseUrl = () => {
  const configuredUrls = process.env.VUE_APP_BASE_URL || 'http://localhost:8080'
  const urlList = configuredUrls.split(',').map(url => url.trim())

  // In browser environment, try to match current domain
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin
    const matchingUrl = urlList.find(url => {
      try {
        return new URL(url).origin === currentOrigin
      } catch {
        return false
      }
    })
    if (matchingUrl) return matchingUrl
  }

  // Fallback to first configured URL
  return urlList[0]
}

const APP_BASE_URL = getBaseUrl()

export const betaLogoutUrl = () => {
  return `${APP_BASE_URL}/sign-in`
}

export const apiUrl = (endpoint) => {
  return `${API_BASE_URL}/${endpoint}`
}

export const appUrl = (path) => {
  return `${APP_BASE_URL}/${path}`
}

// Export function to get current base URL (useful for components)
export const getCurrentBaseUrl = () => APP_BASE_URL

// Export all configured URLs
export const getAllBaseUrls = () => {
  const configuredUrls = process.env.VUE_APP_BASE_URL || 'http://localhost:8080'
  return configuredUrls.split(',').map(url => url.trim())
}